import { render, staticRenderFns } from "./drawerCommon.vue?vue&type=template&id=a1f084c8&scoped=true"
import script from "./drawerCommon.vue?vue&type=script&lang=js"
export * from "./drawerCommon.vue?vue&type=script&lang=js"
import style0 from "./drawerCommon.vue?vue&type=style&index=0&id=a1f084c8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1f084c8",
  null
  
)

export default component.exports